import React, { useState, useEffect } from 'react';
import api from '../services/api';

const fmt = n => Number(n || 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function Reports() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reports').then(r => { setData(r.data); setLoading(false); });
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  const totalBilled = data.revenue.reduce((s, r) => s + Number(r.total_billed || 0), 0);
  const totalCollected = data.revenue.reduce((s, r) => s + Number(r.total_collected || 0), 0);
  const totalOutstanding = data.revenue.reduce((s, r) => s + Number(r.outstanding || 0), 0);
  const totalConsumption = data.consumption.reduce((s, r) => s + Number(r.total_consumption || 0), 0);

  return (
    <div>
      <h1 className="page-title">Reports</h1>

      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-value text-green">PHP {fmt(totalBilled)}</div>
          <div className="stat-label">Total Billed</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: '#1976d2' }}>PHP {fmt(totalCollected)}</div>
          <div className="stat-label">Total Collected</div>
        </div>
        <div className="stat-card">
          <div className="stat-value text-red">PHP {fmt(totalOutstanding)}</div>
          <div className="stat-label">Total Outstanding</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{fmt(totalConsumption)} m&sup3;</div>
          <div className="stat-label">Total Consumption</div>
        </div>
      </div>

      <div className="card">
        <h3>Revenue by Barangay</h3>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Barangay</th><th className="text-right">Consumers</th><th className="text-right">Billed</th><th className="text-right">Collected</th><th className="text-right">Outstanding</th></tr></thead>
            <tbody>
              {data.revenue.map((r, i) => (
                <tr key={i}>
                  <td>{r.barangay}</td>
                  <td className="text-right">{r.consumers}</td>
                  <td className="text-right">PHP {fmt(r.total_billed)}</td>
                  <td className="text-right">PHP {fmt(r.total_collected)}</td>
                  <td className="text-right text-red">PHP {fmt(r.outstanding)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h3>Top Delinquent Consumers</h3>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Account</th><th>Name</th><th>Barangay</th><th className="text-right">Unpaid Bills</th><th className="text-right">Total Due</th></tr></thead>
            <tbody>
              {data.delinquent.map((d, i) => (
                <tr key={i}>
                  <td>{d.account_code}</td>
                  <td>{d.name}</td>
                  <td>{d.barangay}</td>
                  <td className="text-right">{d.unpaid_bills}</td>
                  <td className="text-right text-red">PHP {fmt(d.total_due)}</td>
                </tr>
              ))}
              {data.delinquent.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#666' }}>No delinquent consumers</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h3>Consumption by Barangay</h3>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Barangay</th><th className="text-right">Total (m&sup3;)</th><th className="text-right">Average (m&sup3;)</th><th className="text-right">Max (m&sup3;)</th></tr></thead>
            <tbody>
              {data.consumption.map((c, i) => (
                <tr key={i}>
                  <td>{c.barangay}</td>
                  <td className="text-right">{fmt(c.total_consumption)}</td>
                  <td className="text-right">{fmt(c.avg_consumption)}</td>
                  <td className="text-right">{fmt(c.max_consumption)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
